export function getGoogleTagManager() {
  return import.meta.env.VITE_APP_GTM_TAG
}
